module.exports = __webpack_public_path__ + "static/img/t1@2x.90008e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/picture/t1@2x.jpg
// module id = 9rml
// module chunks = 1